import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EnglishStudyComponent from './EnglishStudyComponent';
import QuestionGeneratorWindow from './components/QuestionGeneratorWindow';
import ShadowingWindow from './components/ShadowingWindow';
import EssayGradingWindow from './components/EssayGradingWindow';
import AILearningDashboard from './components/AILearningDashboard';
import GitHubAuthCallback from './components/GitHubAuthCallback';
import EnglishCareerPath from './components/EnglishCareerPath';
import InteractivePreview from './components/InteractivePreview_backup';

function MainApp() {
  // URL 매개변수로 모드 확인
  const urlParams = new URLSearchParams(window.location.search);
  const isQuestionGenerator = urlParams.get('mode') === 'question-generator';
  const isShadowingGenerator = urlParams.get('mode') === 'shadowing-generator';
  const isEssayGrading = urlParams.get('mode') === 'essay-grading';
  const isDashboard = urlParams.get('mode') === 'dashboard';
  const isCareerPath = urlParams.get('mode') === 'career-path';
  const isInteractiveEditor = urlParams.get('mode') === 'interactive-editor';

  if (isDashboard) {
    return <AILearningDashboard />;
  }

  if (isCareerPath) {
    return <EnglishCareerPath />;
  }

  if (isInteractiveEditor) {
    return <InteractivePreview onClose={() => window.close()} />;
  }


  if (isEssayGrading) {
    return <EssayGradingWindow />;
  }

  if (isShadowingGenerator) {
    return <ShadowingWindow />;
  }

  if (isQuestionGenerator) {
    return <QuestionGeneratorWindow />;
  }


  return (
    <div>
      <EnglishStudyComponent />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/auth/github/callback" element={<GitHubAuthCallback />} />
        <Route path="/*" element={<MainApp />} />
      </Routes>
    </Router>
  );
}

export default App;
